// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"47ecb726","348":"e4d0dc18","571":"ce14b73f","924":"3262de38"}[chunkId] + ".chunk.js";
};